"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BadgeType = exports.Badge = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _BadgeModule = _interopRequireDefault(require("./Badge.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var BadgeType = exports.BadgeType = {
  error: '--error',
  information: '--infomation',
  promo: '--promo',
  promo_100: '--promo_100',
  neutral_15: '--neutral_15',
  neutral_64: '--neutral_64',
  neutral_white: '--neutral_white',
  success: '--success',
  warning: '--warning'
};
var Badge = exports.Badge = function Badge(_ref) {
  var _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'Label' : _ref$label,
    _ref$badgeType = _ref.badgeType,
    badgeType = _ref$badgeType === void 0 ? BadgeType.information : _ref$badgeType,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? null : _ref$className;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: (0, _classnames["default"])([_BadgeModule["default"].badge, _BadgeModule["default"]["badgeType".concat(badgeType)], className]),
    "data-jlds": true,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      children: label
    })
  });
};
Badge.propTypes = {
  /** The label to display on the badge */
  label: _propTypes["default"].string,
  /** The badge type (and therefore the color pallette) to be used */
  badgeType: _propTypes["default"].oneOf(Object.values(BadgeType)),
  /** Append custom class to component */
  className: _propTypes["default"].string
};
Badge.displayName = 'Banner';